import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { motion } from 'framer-motion';

export default function BeforeAfter() {
  return (
    <section className="py-24 bg-maaich-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-display uppercase italic">
            Lo Sgombero in <span className="text-maaich-lime">Azione</span>
          </h2>
          <p className="text-white/60 mt-4 font-body">Trascina lo slider per vedere i nostri mezzi all'opera.</p>
        </div>

        <motion.div 
          className="max-w-5xl mx-auto rounded-none border border-white/10 overflow-hidden shadow-2xl"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <ReactCompareSlider
            itemOne={<ReactCompareSliderImage src="https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvanBlZw==/da9cd2428e05b744a2b14733b8d7d6a9.jpeg" alt="Prima - Furgone Vuoto" />}
            itemTwo={<ReactCompareSliderImage src="https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvanBlZw==/ab87df4aa82e0562161154303220705f.jpeg" alt="Dopo - Furgone Pieno" />}
            className="h-[400px] md:h-[600px] w-full object-cover"
            handle={
              <div className="w-1 h-full bg-maaich-lime relative flex items-center justify-center cursor-ew-resize">
                <div className="w-10 h-10 bg-maaich-black border-2 border-maaich-lime rounded-full flex items-center justify-center shadow-lg">
                  <div className="flex gap-1">
                    <div className="w-1 h-3 bg-white/50 rounded-full"></div>
                    <div className="w-1 h-3 bg-white/50 rounded-full"></div>
                  </div>
                </div>
              </div>
            }
          />
        </motion.div>
      </div>
    </section>
  );
}